import React, { useState } from 'react';
import '../styles/HomeContact.css';

const HomeContact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
  });

  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.phone) {
      setStatus('Please fill in all fields');
      return;
    }

    try {
      const res = await fetch(
  `${process.env.REACT_APP_CONTACT_API_URL}?action=add`,
  {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      purpose: "Request a call back",
    }),
  }
);


      const result = await res.json();

      if (result.success) {
        setStatus('Submitted successfully!');
        setFormData({ name: '', email: '', phone: '' });
      } else {
        setStatus('Submission failed: ' + result.message);
      }
    } catch (error) {
      setStatus('Network error. Please try again.');
    }
  };

  return (
    <div className="home-contact">
      <div className="home-contact-sub">
        {/* contact image start */}
        <div className="form-image"></div>
        {/* contact image end */}

        {/* contact form circle start */}
        <div className="form-circle">
          <div className="circle-one">
            <div className="circle-two">
              <div className="circe-content">
                <h1 className="circle-content-head">Request A Call Back.... </h1>
              
                <div className='main-form'>
                     <form onSubmit={handleSubmit}>
                  <input
                    type="text"
                    placeholder="Enter Name"
                    name="name"
                    id="fullname"
                    value={formData.name}
                    onChange={handleChange}
                  />
                  <input
                    type="email"
                    placeholder="Email Address"
                    name="email"
                    id="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  <input
                    type="tel"
                    placeholder="Enter phone"
                    name="phone"
                    id="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                  <br/>
                  <div className='contact-submit'>
                       <button type="submit" name="submit" className="submit">
                    Submit
                  </button>
                  </div>
                 
                </form>
                </div>
              
                {status && <p style={{ marginTop: '10px', color: '#fff' }}>{status}</p>}
              </div>
            </div>
          </div>
        </div>
        {/* contact form circle end */}
      </div>
    </div>
  );
};

export default HomeContact;
